export default __webpack_public_path__ + "static/media/help.6298a8b3.svg";